import React from 'react';
import ReactFlipCard from 'reactjs-flip-card';
import data from '../data.json';  
import '../css/management.css';

function Management() {

  const styles = {
    card: { background: '#f5f5f5', color: 'white', borderRadius: 0 },
  };

  return (
    <div className='management-team-sec'>
      <div className='management-main-box'>
        {data.VisionaryLeaders.map((person) => (
          <ReactFlipCard
            key={person.id}
            frontStyle={styles.card}
            backStyle={styles.card}
            frontComponent={
              <div className='visionary-box'>
                <div className="visionary-img-box">
                  <img src={person.img} alt={person.Name} />
                  <div className="visionary-name-box">
                    <h1>{person.Name}</h1>
                    <h3>{person.post}</h3>
                  </div>
                </div>
              </div>
            }
            backComponent={
              <div className="management-back">
                <h1>{person.Name} ({person.post})</h1>
                <p>{person.content}</p>
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
}

export default Management;
